<!-- @veltra/icons generated sha256:36ab9ce3925a4475 gen:8 source:src/svg/normal/share.svg -->
<script setup lang="ts">
defineOptions({ name: 'Share' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M9.932 5.358a2.317 2.317 0 1 0-.504-.864l-3.36 1.96a2.317 2.317 0 1 0 0 3.143l3.36 1.959a2.317 2.317 0 1 0 .505-.863l-3.36-1.959a2.3 2.3 0 0 0 0-1.416zm1.702-2.89a1.317 1.317 0 1 1 0 2.635 1.317 1.317 0 0 1 0-2.634M5.488 7.338l.03.053a1.31 1.31 0 0 1-.03 1.326 1.317 1.317 0 1 1 0-1.38m4.83 4.93c0-.218.052-.423.145-.604a.5.5 0 0 0 .071-.121 1.316 1.316 0 0 1 2.418.725 1.317 1.317 0 1 1-2.635 0"
    />
  </svg>
</template>
